// extracted by mini-css-extract-plugin
export default {"editableSpanContainer":"HW6_editableSpanContainer__ddK55","buttonsContainer":"HW6_buttonsContainer__y2lCq"};